import { definePartner } from "../definePartner";

/**
 * Exclusife: lists and applies offers, but only for a customer Exclusife has verified (`applyOtp: required`), which the app never does; typed codes redeem with an OTP.
 *
 * The app has no conversation of its own with it yet: every conversation field is the baseline's,
 * exactly as before it had a folder (R2.2 changed no behaviour). A gap between what the backend
 * offers and what the app does is asked when R2.4 builds the partner steps (DISCOUNT_V2_PLAN.md §9.12).
 */
export default definePartner("exclusife", {
  name: "Exclusife",
  backend: {
    listsOffers: true,
    appliesOffers: true,
    applyOtp: "required",
    takesTypedCodes: true,
    releaseNeeds: [],
    exercisedAtSave: false,
  },
  // The backend defines `refundLoyaltyPoints` for it (points-conversations.md §2).
  refundsPoints: true,
  // A typed code is redeemed with the customer's OTP (`coupon/redeem`; old FE ItemEditController.js 1358-1374). A wrong OTP is a refused redeem, with nothing blocked to release.
  codeNeedsOtp: true,
});
